import React from 'react';
import SvgIcon from '../../Components/Icons/SvgIcon';
import PinMarker from '../../Components/Icons/PinMarker';

interface IProps {
    className?: string;
    lat: number;
    lng: number;
    mapNum: string | number;
    zIndex: number;
}

const MapPinMarker: React.FC<IProps> = (props) => {
    const width: number = 30;
    const height: number = 40;

    return (
        <div
            className={`absolute flex justify-center items-center ${props.className}`}
            style={{
                width: `${width}px`,
                height: `${height}px`,
                left: `-${width/2}px`,
                top: `-${height}px`,
                zIndex: props.zIndex
            }}
        >
            <span className="absolute z-10 font-bold text-white text-base" style={{ top: `-${height/8}px`}}>{props.mapNum}</span>
            <SvgIcon
                width={`${width}`}
                viewBox={`0 0 ${width} ${height}`}
                height={`${height}`}
            >
                <PinMarker />
            </SvgIcon>
        </div>
    )
}

export default MapPinMarker;
